<div
   *ngIf="!dialogApplications"
   class="ui-g-12 ui-lg-12 text-right"
   style="float:unset;">
    <button pButton type="button"
            class="k-generic-btn"
            icon="fa fa-angle-left"
            iconPos="left"
            (click)="onCustomButton()"
            label="{{ 'common.back' | translate }}"></button>
</div>

<app-kontable
        id="dt_user_applications"
        *ngIf="activeUser"
        title="{{ 'userApplications.sectionTitle' | translate }} {{activeUser.login}}"
        [columns]="['application_name',
            { field: 'date_start', bodyTemplate: dateField, title: 'userApplications.date_start' },
            { field: 'date_end', bodyTemplate: dateField, title: 'userApplications.date_end' }
        ]"
        [titles]="['common.application', 'userApplications.date_start', 'userApplications.date_end']"
        [source]="selectedApplicationsClone"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showInfoButton]="false"
        [showRolesButton]="showRolesButton"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="openDialog($event)"
        (onEdit)="openDialog($event)"
        (onRemove)="deleteElement($event)"
        (manageRolesSelected)="manageRoles($event)">
    <ng-template #dateField data-testid="dateField" let-row let-value="value">{{value | date: srvCalTranslate.pcalendarTranslate.dateFormatFilter }}</ng-template>
</app-kontable>

<p-dialog
        *ngIf="showDialog"
        [(visible)]="showDialog"
        [modal]="true"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()"
        [header]="dialogTitle">
    <form *ngIf="fields && form" [ngClass]="{'invalid-submit': invalidSubmit}" style="padding-left: 20px;" [formGroup]="form" (ngSubmit)="saveOrUpdate()" class="bottom-10-margin" RestrictFocus>
        <div class="ui-grid ui-grid-responsive ui-fluid">
            <div class="ui-grid-row bottom-10-margin">
                <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.application_name.nullable}">{{ fields.application_name.keyName }}</label></div>
                <div class="ui-grid-col-8">
                    <p-dropdown
                            formControlName="application_name"
                            [options]="applications"
                            multiple="single"
                            filter="filter"
                            [style]="{ 'width': '100%'}"
                    ></p-dropdown>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.application_name"></app-validation-msg>
                </div>
            </div>
            <div class="ui-grid-row bottom-10-margin">
                <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName }}</label></div>
                <div class="ui-grid-col-8">
                    <app-kv-calendar
                      #dateStartField
                      [inputName]="'date_start'"
                      [formData]="form"
                      [maxDate]="dateStartMax"
                      [defaultDate]="defaultDateStart"
                      [defaultValue]="defaultDateStart"
                      [startDateSelector]="true"
                      [endDateInputName]="'date_end'"
                      [endDateCalendar]="dateEndField"
                    >
                    </app-kv-calendar>
                    <span class="input-error-notification" *ngIf="dateStartIssue">{{ 'common.startDateLimit' | translate }}</span>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.date_start"></app-validation-msg>
                </div>
            </div>
            <div class="ui-grid-row bottom-10-margin">
                <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</label></div>
                <div class="ui-grid-col-8">
                    <app-kv-calendar
                      #dateEndField
                      [inputName]="'date_end'"
                      [formData]="form"
                      [minDate]="dateEndMin"
                      [defaultDate]="defaultDateEnd"
                      [defaultValue]="defaultDateEnd"
                      [endDateSelector]="true"
                      [startDateInputName]="'date_start'"
                      [startDateCalendar]="dateStartField"
                      >
                  </app-kv-calendar>
                  <span class="input-error-notification" *ngIf="dateEndIssue">{{ 'common.endDateLimit' | translate }}</span>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.date_end"></app-validation-msg>
                </div>
            </div>
        </div>
        <p-footer>
            <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
                <button type="submit"
                        class="k-generic-btn"
                        pButton icon="fa fa-plus"
                        label="{{ btntraduction | translate }}"
                ></button>
            </div>
        </p-footer>
    </form>
</p-dialog>

<p-dialog
*ngIf="showRolesDialog"
[(visible)]="showRolesDialog"
[modal]="true"
[minWidth]="500"
[draggable]="false"
[resizable]="false"
(onHide)="showRolesDialog = false"
[header]="rolesDialogTitle">
  <app-user-app-role-management
  [rolesForUserApp]="rolesForUserApp"
  [activeRolesForUserApp]="activeRolesForUserApp"
  [userId]="activeUser.id"
  [baseUrl]="selectedApplicationBaseUrl">
  </app-user-app-role-management>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/users/userApplication.component.html